"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
;
var IsAddressChange = /** @class */ (function (_super) {
    __extends(IsAddressChange, _super);
    function IsAddressChange(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: form_store_1.default.getState().data.is_address_change,
            error: form_store_1.default.getState().error.is_address_change
        };
        form_store_1.default.on("STATE_CHANGE", function () {
            var new_state = form_store_1.default.getState();
            _this.setState({
                value: new_state.data.is_address_change,
                error: new_state.error.is_address_change,
            });
        });
        return _this;
    }
    IsAddressChange.prototype.render = function () {
        var _a = this.state, value = _a.value, error = _a.error, errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
        if (error.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, error[0]));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("ul", { className: "input-list input-list--vertical" },
                react_1.default.createElement("li", { className: "input-list__item" },
                    react_1.default.createElement("label", { className: "input-radio" },
                        react_1.default.createElement("input", { className: "input-radio__input", type: "radio", name: "is_address_change", value: "1", checked: parseInt(value) === 1, onChange: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-radio__text" }, "\u30AF\u30EA\u30CB\u30C3\u30AF\u306B\u767B\u9332\u3057\u3066\u3044\u308B\u4F4F\u6240\u306B\u5909\u66F4\u306F\u306A\u3044\u3002"))),
                react_1.default.createElement("li", { className: "input-list__item" },
                    react_1.default.createElement("label", { className: "input-radio" },
                        react_1.default.createElement("input", { className: "input-radio__input", type: "radio", name: "is_address_change", value: "2", checked: parseInt(value) === 2, onChange: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-radio__text" }, "\u30AF\u30EA\u30CB\u30C3\u30AF\u306B\u767B\u9332\u3057\u3066\u3044\u308B\u4F4F\u6240\u306B\u5909\u66F4\u304C\u3042\u3063\u305F\u304C\u3001\u3055\u304D\u307B\u3069\uFF08\u4ECA\u304B\u308924\u6642\u9593\u4EE5\u5185\u306B\uFF09\u5909\u66F4\u624B\u7D9A\u304D\u306F\u5B8C\u4E86\u3057\u305F")))),
            react_1.default.createElement("p", { className: "form__note" },
                "\u4F4F\u6240\u5909\u66F4\u306F",
                react_1.default.createElement("a", { href: "contact/change", target: "_blank" }, "\u4F4F\u6240\u30FB\u96FB\u8A71\u756A\u53F7\u5909\u66F4\u9023\u7D61\u30D5\u30A9\u30FC\u30E0"),
                "\u304B\u3089\u304A\u9858\u3044\u305F\u3057\u307E\u3059\u3002\u51CD\u7D50\u7CBE\u5B50\u3084\u80DA\u306A\u3069\u304C\u3042\u308B\u5834\u5408\u306B\u4F4F\u6240\u5909\u66F4\u304C\u3055\u308C\u3066\u3044\u306A\u3044\u3068\u9023\u7D61\u304C\u3064\u304B\u306A\u3044\u305F\u3081\u3001\u5F53\u9662\u306E\u51CD\u7D50\u898F\u5B9A\u306E\u901A\u308A\u6240\u6709\u6A29\u306F\u5F53\u9662\u306B\u5E30\u5C5E\u3057\u307E\u3059\u3002")));
    };
    return IsAddressChange;
}(react_1.Component));
exports.default = IsAddressChange;
